import { Component, OnInit } from '@angular/core';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { Constants } from '@base/src/app/models/constants';
import { Overlay } from '@base/src/app/models/overlay.model';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRChip } from '@base/src/app/models/qr-chip.model';
import { QRInput } from '@base/src/app/models/qr-input.model';
import { EvaluationTypesActionsService } from '@base/src/app/pages/recruitment/services/evaluation-types-actions.service';
import { EvaluationTypeService } from '@base/src/app/pages/recruitment/services/evaluation-types.service';
import { SnackbarService } from '@base/src/app/services/snackbar.service';
import { UtilsService } from '@base/src/app/services/utils.service';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-config-score',
  templateUrl: './config-score.component.html',
  styleUrls: ['./config-score.component.scss'],
})
export class RecruitmentConfigScoreComponent implements OnInit {
  evaluationList: { id: number; evaluation: string }[] = [];

  readonly ACTION_ADD = 'add';
  readonly ACTION_EDIT = 'edit';
  readonly ACTION_DELETE = 'delete';

  buttonAdd: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.PLUS,
    viewValue: 'Agregar',
  };

  chipEvaluation: QRChip = {
    hierarchy: QRChip.HIERARCHY_3,
    size: QRChip.SIZE_SMALL,
  };

  buttonEdit: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  buttonDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.DELETE_2,
    iconOnly: true,
  };

  buttonDialogSave: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar',
  };

  buttonDialogDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Si, eliminar',
  };

  buttonDialogCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };

  overlay: Overlay = {
    isButtonCloseVisible: false,
    isFullHeight: false,
    doesClickingOutsideContentClose: true,
  };
  isOverlayVisible = false;

  inputAdd: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Párametro de puntaje',
  };

  user: LogedUser | undefined;

  loading = false;

  dialogTitle = '';
  dialogAction = this.ACTION_ADD;
  parameterName = '';
  parameterId = 0;

  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly utils: UtilsService,
    private readonly evaluationTypesActions: EvaluationTypesActionsService,
    private readonly evluationTypes: EvaluationTypeService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.user = this.utils.getLoggedUser();
    this.loadScores();
  }

  loadScores() {
    this.evaluationList = [];
    const ID = this.user?.agency_id.toString() ?? '';
    this.evluationTypes.get(ID).then((response: any) => {
      if (response?.data) {
        this.evaluationList = [...response.data];
        this.loading = false;
      }
    });
  }

  onAdd() {
    if (this.evaluationList.length >= 10) {
      this.snackbarService.openWithVariableDuration(
        'El proceso de reclutamiento permite un MÁXIMO de 10 parámetros de puntaje.',
        '',
        4000
      );
    } else {
      this.dialogAction = this.ACTION_ADD;
      this.dialogTitle = 'Agregar parámetro de puntaje';
      this.isOverlayVisible = true;
      this.parameterName = '';
      this.parameterId = 0;
      this.inputAdd.hint = (this.parameterName.length ?? 0) + '/30';
    }
  }

  onEdit(evaluation: { id: number; evaluation: string }) {
    this.isOverlayVisible = true;
    this.dialogAction = this.ACTION_EDIT;
    this.parameterId = evaluation.id;
    this.parameterName = evaluation.evaluation;
    this.dialogTitle = 'Modificar nombre';
    this.inputAdd.hint = (this.parameterName.length ?? 0) + '/30';
  }

  onDelete(evaluation: { id: number; evaluation: string }) {
    this.isOverlayVisible = true;
    this.dialogAction = this.ACTION_DELETE;
    this.parameterId = evaluation.id;
    this.parameterName = evaluation.evaluation;
    this.dialogTitle = 'Eliminar parámetro de puntaje';
  }

  changeInputAdd($event: InputTypes) {
    if ($event) {
      const RESULT = $event.toString();
      this.validateName(RESULT);
    } else {
      this.parameterName = '';
      this.inputAdd.hint = '0/30';
    }
  }

  validateName(result: string) {
    if (result.length < 31) {
      this.parameterName = result;
      this.inputAdd.hint = (this.parameterName.length ?? 0) + '/30';
    } else {
      this.snackbarService.openSnackBar(
        'El máximo permitido de caracteres es 30',
        ''
      );
    }
  }

  generateDto(): {
    agencyId: number | undefined;
    loggedUser: string | undefined;
    evaluation?: string;
    id?: number;
  } {
    let dto: {
      agencyId: number | undefined;
      loggedUser: string | undefined;
      evaluation?: string;
      id?: number;
    } = {
      agencyId: undefined,
      loggedUser: undefined,
    };
    switch (this.dialogAction) {
      case this.ACTION_ADD:
        dto = {
          agencyId: this.user?.agency_id,
          loggedUser: this.user?.username,
          evaluation: this.parameterName,
        };
        break;
      case this.ACTION_EDIT:
        dto = {
          agencyId: this.user?.agency_id,
          loggedUser: this.user?.username,
          evaluation: this.parameterName,
          id: this.parameterId,
        };
        break;
      case this.ACTION_DELETE:
        dto = {
          agencyId: this.user?.agency_id,
          loggedUser: this.user?.username,
          id: this.parameterId,
        };
        break;
    }
    return dto;
  }

  onSave() {
    if (!this.parameterName) {
      this.snackbarService.openSnackBar('Ingrese un nombre', '');
    } else {
      this.loading = true;
      const DTO = this.generateDto();
      switch (this.dialogAction) {
        case this.ACTION_ADD:
          this.evaluationTypesActions.post(DTO, '').then((response: any) => {
            if (response?.body?.code == 200) {
              this.snackbarService.openSnackBar(response.body.message, '');
              this.loadScores();
            }
          });
          break;
        case this.ACTION_EDIT:
          this.evaluationTypesActions.put(DTO, '').then((response: any) => {
            if (response?.body?.code == 200) {
              this.snackbarService.openSnackBar(response.body.message, '');
              this.loadScores();
            }
          });
          break;
        case this.ACTION_DELETE:
          this.evaluationTypesActions
            .post(DTO, this.ACTION_DELETE)
            .then((response: any) => {
              if (response?.body?.code == 200) {
                this.snackbarService.openSnackBar(response.body.message, '');
                this.loadScores();
              }
            });
          break;
      }
      this.loading = false;
      this.isOverlayVisible = false;
    }
  }

  onKeyDown(e: KeyboardEvent) {
    if (this.parameterName.length >= 30 && !this.isDeleteOrBackspace(e)) {
      e.preventDefault();
    }
  }

  isDeleteOrBackspace(event: KeyboardEvent): boolean {
    return event.key === 'Backspace' || event.key === 'Delete';
  }
}
